import { groupBy, mapValues } from 'lodash-es'
import type { optionType } from './dictionary.ts'
import {
    DegreeType,
    EducationDetailsType,
    EducationType,
    ExpertiseType,
    FormOfCollaborationType,
    JobFeeType,
    JobPlaceType,
    JobTimeType,
    JobType,
    LanguageLevelType,
    SkillLevelType,
    StartType,
    WhoType
} from './Job.ts'

export const wanted: optionType[] = [
    {
        id: 'dobrovolnik',
        value: 'dobrovolnik',
        label: 'dobrovoľníka'
    },
    { id: 'clen_timu', value: 'clen_timu', label: 'člena tímu' }
]

export const creativity: optionType[] = [
    {
        id: 'yes',
        value: 'yes',
        label: 'Rola ponúka príležitosť vymýšľať nové návrhy / koncepty / stratégie'
    },
    {
        id: 'no',
        value: 'no',
        label: 'Rola ponúka skôr príležitosť implementovať, čo ostatní vymyslia'
    }
]
export const clarity: optionType[] = [
    {
        id: 'yes',
        value: 'yes',
        label: 'Rola ponúka stabilitu v procesoch'
    },
    {
        id: 'no',
        value: 'no',
        label: 'Rola ponúka dynamickosť, prípadne možnosť tvoriť procesy za chodu'
    }
]
export const multitasking: optionType[] = [
    {
        value: 'yes',
        id: 'yes',
        label: 'Rola vyžaduje prácu na viacerých zadaniach naraz'
    },
    {
        id: 'no',
        value: 'no',
        label: 'Rola vyžaduje prácu na jednom zadaní v jednom čase'
    }
]
export const teamwork: optionType[] = [
    {
        id: 'yes',
        value: 'yes',
        label: 'Rola vyžaduje tímovú prácu na úlohách'
    },
    {
        id: 'no',
        value: 'no',
        label: 'Rola vyžaduje samostatnosť'
    }
]

export const clients: optionType[] = [
    {
        id: 'yes',
        value: 'yes',
        label: 'Rola zahŕňa veľa času s klientom / zákazníkom'
    },
    {
        id: 'no',
        value: 'no',
        label: 'Rola zahŕňa málo, až žiadny kontakt s klientom / zákazníkom'
    }
]

export const languageLevels: optionType[] = [
    {
        id: LanguageLevelType.A1,
        value: LanguageLevelType.A1,
        label: 'A1 - úplný začiatočník'
    },
    {
        id: LanguageLevelType.A2,
        value: LanguageLevelType.A2,
        label: 'A2 - začiatočník'
    },
    {
        id: LanguageLevelType.B1,
        value: LanguageLevelType.B1,
        label: 'B1 - mierne pokročilý'
    },
    {
        id: LanguageLevelType.B2,
        value: LanguageLevelType.B2,
        label: 'B2 - stredne pokročilý'
    },
    {
        id: LanguageLevelType.C1,
        value: LanguageLevelType.C1,
        label: 'C1 - pokročilý'
    },
    {
        id: LanguageLevelType.C2,
        value: LanguageLevelType.C2,
        label: 'C2 - expert'
    }
]
export const skillLevels: optionType[] = [
    {
        id: SkillLevelType.A1,
        value: SkillLevelType.A1,
        label: 'úplný začiatočník'
    },
    {
        id: SkillLevelType.A2,
        value: SkillLevelType.A2,
        label: 'začiatočník'
    },
    {
        id: SkillLevelType.B1,
        value: SkillLevelType.B1,
        label: 'mierne pokročilý'
    },
    {
        id: SkillLevelType.B2,
        value: SkillLevelType.B2,
        label: 'stredne pokročilý'
    },
    {
        id: SkillLevelType.C1,
        value: SkillLevelType.C1,
        label: 'pokročilý'
    },
    {
        id: SkillLevelType.C2,
        value: SkillLevelType.C2,
        label: 'expert'
    }
]

export const salaryUnits: optionType[] = [
    {
        id: 'eur-m',
        value: 'EUR / mesiac',
        label: '€ / mesiac'
    },
    { id: 'eur-d', value: 'EUR / deň', label: '€ / deň' },
    {
        id: 'eur-h',
        value: 'EUR / hodinu',
        label: '€ / hodinu'
    }
]

export const jobTypesDictionary: { [key in JobType]: string } = {
    [JobType.fullTime]: 'plný úväzok',
    [JobType.partTime]: 'skrátený úväzok',
    [JobType.internship]: 'študentská stáž',
    [JobType.paidInternship]: 'Stáž platená', // nevyuziva sa
    [JobType.unpaidInternship]: 'Stáž neplatená' // nevyuziva sa
}

export const jobTypesList: optionType[] = [
    {
        id: JobType.fullTime,
        value: JobType.fullTime,
        label: jobTypesDictionary.trvaly_pracovny_pomer
    },
    {
        id: JobType.partTime,
        value: JobType.partTime,
        label: jobTypesDictionary.ciastocny_uvazok
    },
    {
        id: JobType.internship,
        value: JobType.internship,
        label: jobTypesDictionary.staz_pre_studenta
    },
    {
        // nevyuziva sa
        id: JobType.paidInternship,
        value: JobType.paidInternship,
        label: jobTypesDictionary.staz_platena
    },
    {
        // nevyuziva sa
        id: JobType.unpaidInternship,
        value: JobType.unpaidInternship,
        label: jobTypesDictionary.staz_neplatena
    }
]

export const formOfCollaborationDictionary: { [key in FormOfCollaborationType]: string } = {
    [FormOfCollaborationType.permanent]: 'trvalý pracovný pomer',
    [FormOfCollaborationType.agreement]: 'dohoda',
    [FormOfCollaborationType.invoice]: 'na faktúru (živnosť / spoločnosť / freelance)'
}

export const formOfCollaborationList: optionType[] = [
    {
        id: FormOfCollaborationType.permanent,
        value: FormOfCollaborationType.permanent,
        label: formOfCollaborationDictionary.trvaly_pracovny_pomer
    },
    {
        id: FormOfCollaborationType.agreement,
        value: FormOfCollaborationType.agreement,
        label: formOfCollaborationDictionary.dohoda
    },
    {
        id: FormOfCollaborationType.invoice,
        value: FormOfCollaborationType.invoice,
        label: formOfCollaborationDictionary.faktura
    }
]

export const jobPlaceDictionary: { [key in JobPlaceType]: string } = {
    [JobPlaceType.homeoffice]: 'homeoffice',
    [JobPlaceType.office]: 'office',
    [JobPlaceType.hybrid]: 'hybrid'
}

export const jobPlaceList: optionType[] = [
    {
        id: JobPlaceType.homeoffice,
        value: JobPlaceType.homeoffice,
        label: jobPlaceDictionary.homeoffice
    },
    {
        id: JobPlaceType.office,
        value: JobPlaceType.office,
        label: jobPlaceDictionary.office
    },
    {
        id: JobPlaceType.hybrid,
        value: JobPlaceType.hybrid,
        label: jobPlaceDictionary.hybrid
    }
]

export const jobFeeTypeList: optionType[] = [
    {
        id: JobFeeType.SATISFACTION,
        value: JobFeeType.SATISFACTION,
        label: JobFeeType.SATISFACTION
    },
    {
        id: JobFeeType.ADVERTISING,
        value: JobFeeType.ADVERTISING,
        label: JobFeeType.ADVERTISING
    }
]

export const jobTimeDictionary: { [key in JobTimeType]: string } = {
    [JobTimeType.flexible]: 'flexibilný',
    [JobTimeType.static]: 'pevný'
}

export const jobTimeList: optionType[] = [
    {
        id: JobTimeType.flexible,
        value: JobTimeType.flexible,
        label: jobTimeDictionary.flexibilny
    },
    {
        id: JobTimeType.static,
        value: JobTimeType.static,
        label: jobTimeDictionary.pevny
    }
]

export const startTypesList: optionType[] = [
    {
        id: StartType.ASAP,
        value: StartType.ASAP,
        label: 'Ihneď (dohodou)'
    },
    {
        id: StartType.DATE,
        value: StartType.DATE,
        label: 'Vybrať dátum nástupu / Dátum ukončenia výberového procesu'
    }
]

export const degreeOptions: optionType[] = [
    {
        id: DegreeType.highSchoolDiploma,
        value: DegreeType.highSchoolDiploma,
        label: 'maturita'
    },
    {
        id: DegreeType.firstYearOfBachelorsDegree,
        value: DegreeType.firstYearOfBachelorsDegree,
        label: '1. ročník bakalárskeho štúdia'
    },
    {
        id: DegreeType.secondYearOfBachelorsDegree,
        value: DegreeType.secondYearOfBachelorsDegree,
        label: '2. ročník bakalárskeho štúdia'
    },
    {
        id: DegreeType.thirdYearOfBachelorsDegree,
        value: DegreeType.thirdYearOfBachelorsDegree,
        label: '3. ročník bakalárskeho štúdia'
    },
    {
        id: DegreeType.fourthYearOfBachelorsDegree,
        value: DegreeType.fourthYearOfBachelorsDegree,
        label: '4. ročník bakalárskeho štúdia'
    },
    {
        id: DegreeType.mastersDegree,
        value: DegreeType.mastersDegree,
        label: 'Magisterské/inžinierske štúdium'
    },
    {
        id: DegreeType.phD,
        value: DegreeType.phD,
        label: 'PhD štúdium'
    }
]

export const whoTypesDictionary: { [key in WhoType]: string } = {
    [WhoType.studentSs]: 'stredoškoláka',
    [WhoType.studentVs]: 'vysokoškoláka',
    [WhoType.cerstvyAbsolventVs]: 'čerstvého absolventa vysokej školy',
    [WhoType.mladyProfesional]: 'mladého profesionála (prac. skúsenosti do 3 rokov od ukončenia VŠ)',
    [WhoType.profesional]: 'profesionála'
}

export const whoIdToLabelMap = mapValues(
    groupBy(
        [
            {
                id: WhoType.studentSs,
                label: 'stredoškoláka',
                hint: '',
                groupInfinitiveLabel: 'študenti strednej školy',
                index: 1
            },
            {
                id: WhoType.studentVs,
                label: 'vysokoškoláka',
                hint: '',
                groupInfinitiveLabel: 'študenti vysokej školy',
                index: 2
            },
            {
                id: WhoType.cerstvyAbsolventVs,
                label: 'čerstvého absolventa VŠ',
                hint: '',
                groupInfinitiveLabel: 'čerstvého absolventa VŠ',
                index: 3
            },
            {
                id: WhoType.mladyProfesional,
                label: 'mladého profesionála (prac. skúsenosti do 3 rokov od ukončenia VŠ)',
                hint: '',
                groupInfinitiveLabel: 'mladého profesionála (prac. skúsenosti do 3 rokov od ukončenia VŠ)',
                index: 4
            },
            {
                id: WhoType.profesional,
                label: 'profesionála',
                hint: '',
                groupInfinitiveLabel: 'profesionáli',
                index: 5
            }
        ],
        'id'
    ),
    (value) => value[0]
)

export const whoOptionsList: optionType[] = [
    {
        id: WhoType.studentSs,
        value: WhoType.studentSs,
        label: whoTypesDictionary.student_ss
    },
    {
        id: WhoType.studentVs,
        value: WhoType.studentVs,
        label: whoTypesDictionary.student_vs
    },
    {
        id: WhoType.cerstvyAbsolventVs,
        value: WhoType.cerstvyAbsolventVs,
        label: whoTypesDictionary.cerstvy_absolvent_vs
    },
    {
        id: WhoType.mladyProfesional,
        value: WhoType.mladyProfesional,
        label: whoTypesDictionary.mlady_profesional
    },
    {
        id: WhoType.profesional,
        value: WhoType.profesional,
        label: whoTypesDictionary.profesional
    }
]

export const educationOptionsList: optionType[] = [
    {
        id: EducationType.humanitiesAndSocialSciences,
        value: EducationType.humanitiesAndSocialSciences,
        label: 'Humanitné a spoločenské vedy'
    },
    {
        id: EducationType.economicsAndLaw,
        value: EducationType.economicsAndLaw,
        label: 'Ekonomické a právne vedy'
    },
    {
        id: EducationType.marketingCommunicationAndMedia,
        value: EducationType.marketingCommunicationAndMedia,
        label: 'Marketing, komunikácia, médiá'
    },
    {
        id: EducationType.naturalSciencesMathematicsAndInformationTechnologies,
        value: EducationType.naturalSciencesMathematicsAndInformationTechnologies,
        label: 'Prírodné vedy, matematika a informatika'
    },
    {
        id: EducationType.technicalSciencesAndEngineering,
        value: EducationType.technicalSciencesAndEngineering,
        label: 'Technické vedy'
    },
    { id: EducationType.art, value: EducationType.art, label: 'Umenie' },
    {
        id: EducationType.teachingAndEducationSciences,
        value: EducationType.teachingAndEducationSciences,
        label: 'Učiteľstvo a pedagogické vedy'
    },
    {
        id: EducationType.medicineMedicalAndPharmaceuticalSciences,
        value: EducationType.medicineMedicalAndPharmaceuticalSciences,
        label: 'Zdravotníctvo, zdravotnícke a farmaceutické vedy'
    },
    {
        id: EducationType.agriculturalAndVeterinarySciences,
        value: EducationType.agriculturalAndVeterinarySciences,
        label: 'Poľnohospodárske a veterinárske vedy'
    },
    {
        id: EducationType.services,
        value: EducationType.services,
        label: 'Služby'
    },
    {
        id: EducationType.physicalEducationAndSportsSciences,
        value: EducationType.physicalEducationAndSportsSciences,
        label: 'Telesná výchova a šport'
    },
    {
        id: EducationType.interMultidisciplinaryPrograms,
        value: EducationType.interMultidisciplinaryPrograms,
        label: 'Medziodborové program'
    }
]

export const expertise: optionType[] = [
    {
        id: ExpertiseType.administration,
        value: ExpertiseType.administration,
        label: 'Administratíva'
    },
    {
        id: ExpertiseType.analysisAndPolicyMaking,
        value: ExpertiseType.analysisAndPolicyMaking,
        label: 'Analýza a tvorba politík'
    },
    {
        id: ExpertiseType.architecture,
        value: ExpertiseType.architecture,
        label: 'Architektúra'
    },
    {
        id: ExpertiseType.businessDevelopment,
        value: ExpertiseType.businessDevelopment,
        label: 'Business development'
    },
    {
        id: ExpertiseType.finance,
        value: ExpertiseType.finance,
        label: 'Financie'
    },
    {
        id: ExpertiseType.informationTechnology,
        value: ExpertiseType.informationTechnology,
        label: 'Informačné technológie'
    },
    {
        id: ExpertiseType.innovationAndStrategy,
        value: ExpertiseType.innovationAndStrategy,
        label: 'Inovácie a stratégie'
    },
    {
        id: ExpertiseType.humanResources,
        value: ExpertiseType.humanResources,
        label: 'Ľudské zdroje'
    },
    {
        id: ExpertiseType.marketing,
        value: ExpertiseType.marketing,
        label: 'Marketing'
    },
    { id: ExpertiseType.law, value: ExpertiseType.law, label: 'Právo' },
    {
        id: ExpertiseType.translationsAndInterpreting,
        value: ExpertiseType.translationsAndInterpreting,
        label: 'Preklady a tlmočníctvo'
    },
    {
        id: ExpertiseType.projectManagement,
        value: ExpertiseType.projectManagement,
        label: 'Projektový manažment'
    },
    {
        id: ExpertiseType.statisticsAndAnalytics,
        value: ExpertiseType.statisticsAndAnalytics,
        label: 'Štatistika a analytika'
    },
    {
        id: ExpertiseType.technicalDirections,
        value: ExpertiseType.technicalDirections,
        label: 'Technické smery'
    },
    {
        id: ExpertiseType.artAndDesign,
        value: ExpertiseType.artAndDesign,
        label: 'Umenie a dizajn'
    },
    {
        id: ExpertiseType.scienceResearch,
        value: ExpertiseType.scienceResearch,
        label: 'Veda, výskum'
    },
    {
        id: ExpertiseType.education,
        value: ExpertiseType.education,
        label: 'Vzdelávanie'
    }
]
export const expertiseSimple = expertise.map((x) => x.label)
export const expertiseMap = mapValues(groupBy(expertise, 'value'), (x) => x[0])

export const educationDetailsOptionsMap = {
    [EducationType.humanitiesAndSocialSciences]: [
        {
            id: 'kulturna-antropologia',
            value: EducationDetailsType.culturalAnthropology,
            label: 'Kultúrna antropológia'
        },
        {
            id: 'archeologia',
            value: EducationDetailsType.archeology,
            label: 'Archeológia'
        },
        {
            id: 'sociologia-a-socialna-antropologia',
            value: EducationDetailsType.sociologyAndSocialAnthropology,
            label: 'Sociológia a sociálna antropológia'
        },
        {
            id: 'etnologia',
            value: EducationDetailsType.ethnology,
            label: 'Etnológia'
        },
        {
            id: 'kulturologia',
            value: EducationDetailsType.culturology,
            label: 'Kulturológia'
        },
        {
            id: 'estetika',
            value: EducationDetailsType.aesthethics,
            label: 'Estetika'
        },
        {
            id: 'filozofia',
            value: EducationDetailsType.philosophy,
            label: 'Filozofia'
        },
        {
            id: 'historia',
            value: EducationDetailsType.history,
            label: 'História'
        },
        {
            id: 'religionistika',
            value: EducationDetailsType.religion,
            label: 'Religionistika'
        },
        {
            id: 'politologia',
            value: EducationDetailsType.politicalScience,
            label: 'Politológia'
        },
        {
            id: 'prekladatelstvo-a-tlmocnictvo',
            value: EducationDetailsType.translationAndInterpretation,
            label: 'Prekladateľstvo a tlmočníctvo'
        },
        {
            id: 'psychologia',
            value: EducationDetailsType.psychology,
            label: 'Psychológia'
        },
        {
            id: 'sociologia',
            value: EducationDetailsType.sociology,
            label: 'Sociológia'
        },
        {
            id: 'liberalne-studia',
            value: EducationDetailsType.liberalArts,
            label: 'Liberálne štúdiá'
        }
    ],
    [EducationType.economicsAndLaw]: [
        {
            id: 'ekonomia',
            value: EducationDetailsType.economics,
            label: 'Ekonómia'
        },
        {
            id: 'financie',
            value: EducationDetailsType.finance,
            label: 'Financie'
        },
        {
            id: 'bankovnictvo',
            value: EducationDetailsType.banking,
            label: 'Bankovníctvo'
        },
        {
            id: 'podnikanie',
            value: EducationDetailsType.entrepreneurship,
            label: 'Podnikanie'
        },
        {
            id: 'uctovnictvo',
            value: EducationDetailsType.accounting,
            label: 'Účtovníctvo'
        },
        {
            id: 'manazment',
            value: EducationDetailsType.management,
            label: 'Manažment'
        },
        {
            id: 'ludske-zdroje-a-personalny-manazment',
            value: EducationDetailsType.humanResourcesAndPersonnelManagement,
            label: 'Ľudské zdroje a personálny manažment'
        },
        {
            id: 'medzinarodne-vztahy',
            value: EducationDetailsType.internationalRelations,
            label: 'Medzinárodné vzťahy'
        },
        { id: 'pravo', value: EducationDetailsType.law, label: 'Právo' }
    ],
    [EducationType.marketingCommunicationAndMedia]: [
        {
            id: 'marketing',
            value: EducationDetailsType.marketing,
            label: 'Marketing'
        },
        {
            id: 'medialne-a-komunikacne-studia',
            value: EducationDetailsType.communicationAndMedia,
            label: 'Mediálne a komunikačné štúdiá'
        },
        {
            id: 'zurnalistika',
            value: EducationDetailsType.journalism,
            label: 'Žurnalistika'
        }
    ],
    [EducationType.naturalSciencesMathematicsAndInformationTechnologies]: [
        { id: 'fyzika', value: EducationDetailsType.physics, label: 'Fyzika' },
        {
            id: 'astronomia',
            value: EducationDetailsType.astronomy,
            label: 'Astronómia'
        },
        {
            id: 'astrofyzika',
            value: EducationDetailsType.astrophysics,
            label: 'Astrofyzika'
        },
        {
            id: 'chemia',
            value: EducationDetailsType.chemistry,
            label: 'Chémia'
        },
        {
            id: 'biochemia',
            value: EducationDetailsType.biochemistry,
            label: 'Biochémia'
        },
        {
            id: 'biologia',
            value: EducationDetailsType.biology,
            label: 'Biológia'
        },
        {
            id: 'geologia',
            value: EducationDetailsType.geology,
            label: 'Geológia'
        },
        {
            id: 'genetika',
            value: EducationDetailsType.genetics,
            label: 'Genetika'
        },
        {
            id: 'environmentalne-vedy',
            value: EducationDetailsType.environmentalSciences,
            label: 'Environmentálne vedy'
        },
        {
            id: 'botanika',
            value: EducationDetailsType.botany,
            label: 'Botanika'
        },
        {
            id: 'antropologia',
            value: EducationDetailsType.anthropology,
            label: 'Antropológia'
        },
        {
            id: 'matematika',
            value: EducationDetailsType.mathematics,
            label: 'Matematika'
        },
        {
            id: 'statistika',
            value: EducationDetailsType.statistics,
            label: 'Štatistika'
        },
        {
            id: 'informatika',
            value: EducationDetailsType.computerScience,
            label: 'Informatika'
        },
        {
            id: 'kybernetika',
            value: EducationDetailsType.cybernetics,
            label: 'Kybernetika'
        },
        {
            id: 'umela-inteligencia',
            value: EducationDetailsType.artificialIntelligence,
            label: 'Umelá inteligencia'
        },
        {
            id: 'kognitivna-veda',
            value: EducationDetailsType.cognitiveScience,
            label: 'Kognitívna veda'
        }
    ],
    [EducationType.technicalSciencesAndEngineering]: [
        {
            id: 'architektura-a-urbanizmus',
            value: EducationDetailsType.architectureAndUrbanism,
            label: 'Architektúra a urbanizmus'
        },
        {
            id: 'priestorove-planovanie',
            value: EducationDetailsType.spatialPlanning,
            label: 'Priestorové plánovanie'
        },
        {
            id: 'stavebnictvo',
            value: EducationDetailsType.construction,
            label: 'Stavebníctvo'
        },
        {
            id: 'strojarstvo',
            value: EducationDetailsType.engineering,
            label: 'Strojárstvo'
        },
        {
            id: 'automatizacia',
            value: EducationDetailsType.automation,
            label: 'Automatizácia'
        },
        {
            id: 'elektrotechnika',
            value: EducationDetailsType.electricalEngineering,
            label: 'Elektrotechnika'
        },
        {
            id: 'energetika',
            value: EducationDetailsType.energy,
            label: 'Energetika'
        },
        {
            id: 'biotechnologie',
            value: EducationDetailsType.biotechnology,
            label: 'Biotechnológie'
        },
        {
            id: 'chemicke-inzinierstvo-a-technologie',
            value: EducationDetailsType.chemicalEngineeringAndTechnologies,
            label: 'Chemické inžinierstvo a technológie'
        },
        {
            id: 'potravinarstvo',
            value: EducationDetailsType.foodIndustry,
            label: 'Potravinárstvo'
        },
        {
            id: 'doprava',
            value: EducationDetailsType.transportation,
            label: 'Doprava'
        }
    ],
    [EducationType.art]: [
        {
            id: 'vytvarne-umenia-socharstvo-maliarstvo-fotografia-dizajn',
            value: EducationDetailsType.visualArts,
            label: 'Výtvarné umenia (sochárstvo, maliarstvo, fotografia, dizajn)'
        },
        {
            id: 'muzicke-umenia-hudba-tanec-divadlo-film',
            value: EducationDetailsType.performingArts,
            label: 'Múzické umenia (hudba, tanec, divadlo, film)'
        }
    ],
    [EducationType.teachingAndEducationSciences]: [
        {
            id: 'pedagogika',
            value: EducationDetailsType.education,
            label: 'Pedagogika'
        },
        {
            id: 'specialna-pedagogika',
            value: EducationDetailsType.specialEducation,
            label: 'Špeciálna pedagogika'
        },
        {
            id: 'andragogika',
            value: EducationDetailsType.andragogy,
            label: 'Andragogika'
        },
        {
            id: 'logopedia',
            value: EducationDetailsType.speechAndLanguageTherapy,
            label: 'Logopédia'
        }
    ],
    [EducationType.medicineMedicalAndPharmaceuticalSciences]: [
        {
            id: 'farmacia',
            value: EducationDetailsType.pharmacy,
            label: 'Farmácia'
        },
        {
            id: 'farmakologia',
            value: EducationDetailsType.pharmacology,
            label: 'Farmakológia'
        },
        {
            id: 'medicina',
            value: EducationDetailsType.medicine,
            label: 'Medicína'
        },
        {
            id: 'osetrovatelstvo',
            value: EducationDetailsType.nursing,
            label: 'Ošetrovateľstvo'
        },
        {
            id: 'socialna-praca',
            value: EducationDetailsType.socialWork,
            label: 'Sociálna práca'
        },
        {
            id: 'verejne-zdravotnictvo',
            value: EducationDetailsType.publicHealth,
            label: 'Verejné zdravotníctvo'
        },
        {
            id: 'zdravotnicke-vedy',
            value: EducationDetailsType.medicalSciences,
            label: 'Zdravotnícke vedy'
        },
        {
            id: 'zubne-lekarstvo',
            value: EducationDetailsType.dentistry,
            label: 'Zubné lekárstvo'
        }
    ],
    [EducationType.agriculturalAndVeterinarySciences]: [
        {
            id: 'polnohospodarstvo',
            value: EducationDetailsType.agriculture,
            label: 'Poľnohospodárstvo'
        },
        {
            id: 'hygiena-potravin',
            value: EducationDetailsType.foodHygiene,
            label: 'Hygiena potravín'
        },
        {
            id: 'veterinarske-lekarstvo',
            value: EducationDetailsType.veterinaryMedicine,
            label: 'Veterinárne lekárstvo'
        }
    ],
    [EducationType.services]: [
        {
            id: 'cestovny-ruch',
            value: EducationDetailsType.tourism,
            label: 'Cestovný ruch'
        },
        {
            id: 'dopravne-sluzby',
            value: EducationDetailsType.transportationService,
            label: 'Dopravné služby'
        }
    ]
}
